import classNames from "classnames";

function Layout({ children, className, centered }) {
  return (
    <div className={classNames("miltis__main", className)}>
      <div
        className={classNames("miltis__container", {
          "miltis__container--centered": centered,
        })}
      >
        <div
          className={classNames("miltis__wrapper", {
            "miltis__wrapper--centered": centered,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;
